<template>
  <div class="content-item module-table">
    <div class="table__filters form" v-if="sizeFilterOptions.length > 1 || unitFilterOptions.length > 1">
      <div class="filters__filter form-group selectbox" v-if="sizeFilterOptions.length > 1">
        <div class="input input-select -optional">
          <select id="size" :class="{ '-filled': size }" v-model="size">
            <option value="">{{ $t('filters.size.label') }}</option>
            <option v-for="(option, index) in sizeFilterOptions" :value="option" :key="index">{{ option }}</option>
          </select>
          <div class="input-background">
            <label for="size" class="control-label select-label">{{ $t('filters.size.label') }}</label>
          </div>
        </div>
      </div>
      <div class="filters__filter form-group selectbox" v-if="unitFilterOptions.length > 1">
        <div class="input input-select -optional">
          <select id="units" :class="{ '-filled': units }" v-model="units">
            <option value="">{{ $t('filters.units.label') }}</option>
            <option v-for="(option, index) in unitFilterOptions" :value="option" :key="index">{{ $t(`odu_downloads_units.${option}`) }}</option>
          </select>
          <div class="input-background">
            <label for="units" class="control-label select-label">{{ $t('filters.units.label') }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="table__table">
      <table>
        <thead>
        <tr>
          <th>{{ $t('table.head.name') }}</th>
          <th>{{ $t('table.head.format') }}</th>
          <th>{{ $t('table.head.size') }}</th>
          <th>{{ $t('table.head.language') }}</th>
          <th>{{ $t('table.head.itemNumber') }}</th>
          <th>{{ $t('table.head.download') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.name }}</td>
          <td>{{ item.extension }}</td>
          <td>{{ item.size | formatBytes }}</td>
          <td>{{ $t(`odu_downloads_language.${item.odu_downloads_language}`) }}</td>
          <td>{{ item.odu_downloads_item_number }}</td>
          <td><a :href="`/fileadmin/${item.identifier}`" target="_blank" @click="handleDownload(`/fileadmin/${item.identifier}`)">Download</a></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    size: {
      get () {
        return this.$store.state.size
      },
      set (size) {
        this.$store.commit('setSize', size)
      }
    },
    units: {
      get () {
        return this.$store.state.units
      },
      set (units) {
        this.$store.commit('setUnits', units)
      }
    },
    ...mapGetters({
      items: 'filteredItems'
    }),
    ...mapGetters([
      'sizeFilterOptions',
      'unitFilterOptions'
    ])
  },
  methods: {
    ...mapActions({
      initStore: 'init'
    }),
    handleDownload: function (val) {
      if (window.dataLayer) {
        window.dataLayer.push({
          'stp-file-cad': val,
          event: 'stp-file-cad-download-event'
        })
      }
    }
  },
  filters: {
    formatBytes (bytes) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  },
  created () {
    this.initStore()
  }
}
</script>
